import styled from 'styled-components';

export const InputContainer = styled.div`
  input {
    height: 48px;
  }
`;

export const InputLabel = styled.div`
  width: 304px;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.13;
  letter-spacing: normal;
  color: ${({ theme }) => theme.onBackgroundColor};
  display: flex;

  svg {
    margin-left: auto;
    cursor: pointer;
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.primaryColor};
  }
`;

export const ErrorLabel = styled.div`
  color: ${({ theme }) => theme.errorAlertBorderColor};
  margin: 5px 0;
  font-size: 12px;
`;
